import { Tooltip } from 'antd';
import { FC, ReactElement, ReactNode } from 'react';

type DisabledActionTooltipProps = {
  children: ReactElement;
  title: ReactNode;
  className?: string;
};

export const DisabledActionTooltip: FC<DisabledActionTooltipProps> = (
  props,
) => {
  const { children, title, className } = props;

  return (
    <Tooltip title={title}>
      {/* antd needs a wrapper to hang a tooltip off a disabled button. */}
      <span className={className}>{children}</span>
    </Tooltip>
  );
};
